import { experiment } from "@faire/web--source/common/settings/declarations/experiment";
/**
 * Controls whether page data is loaded across the app vs from the root layout.
 */ export var FE_DECENTRALIZE_PAGE_DATA_250214 = experiment({
    name: "FE_DECENTRALIZE_PAGE_DATA_250214",
    identifier: "SessionToken",
    client: "RETAILER",
    notifyAfter: "2025-05-07",
    productArea: "WEB_SERVER_SIDE_RENDERING",
    defaultValue: false
});
